<template>
  <ul class="custom_radio gender_select" :class="item.class">
    <li class="mr10">
      <input type="radio" id="radio_2_1" name="radio_2" v-model="item.values" value="M">
      <label for="radio_2_1" v-text="$t('patient.info.gender.male')">
      </label>
    </li>
    <li>
      <input type="radio" id="radio_2_2" name="radio_2" v-model="item.values" value="F">
      <label for="radio_2_2" v-text="$t('patient.info.gender.female')">
      </label>
    </li>
  </ul>
</template>
<script>
  export default {
      props : ['item'],
  }
</script>